import React from 'react';
export default function FaqData() {
    return [
        {
            title: "What is Long Term Care (LTC)?",
            text: [
                "Long-term care is a range of services and supports you may need to meet your personal care needs. Most long-term care is not medical care, but rather assistance with the basic personal tasks of everyday life, sometimes called Activities of Daily Living (ADLs), such as:",
                ["Bathing",
                    "Dressing",
                    "Using the toilet",
                    "Transferring (to or from bed or chair)",
                    "Caring for incontinence",
                    "Eating"],

                "Other common long-term care services and supports are assistance with everyday tasks, sometimes called Instrumental Activities of Daily Living (IADLs) including:",
                ["Housework",
                    "Managing money",
                    "Taking medication",
                    "Preparing and cleaning up after meals",
                    "Shopping for groceries or clothes",
                    "Using the telephone or other communication devices",
                    "Caring for pets",
                    "Responding to emergency alerts such as fire alarms",
                ],
                "Information provided by LongTermCare.gov"
            ]
        },
        {
            title: "Who needs care?",
            text: [
                "70% of people turning age 65 can expect to use some form of long-term care during their lives. There are a number of factors that affect the possibility that you will need care:",
                <strong>Age</strong>,
                "The older you are, the more likely you will need long-term care",
                <strong>Gender</strong>,
                "Women outlive men by about five years on average, so they are more likely to live at home alone when they are older",
                <strong>Disability</strong>,
                ["Having an accident or chronic illness that causes a disability is another reason for needing long-term care",
                    "Between ages 40 and 50, on average, eight percent of people have a disability that could require long-term care services",
                    "69 percent of people age 90 or more have a disability"],
                <strong>Health Status</strong>,
                ["Chronic conditions such as diabetes and high blood pressure make you more likely to need care",
                    "Your family history such as whether your parents or grandparents had chronic conditions, may increase your likelihood",
                    "Poor diet and exercise habits increase your chances of needing long-term care",
                ],
                <strong>Living Arrangements</strong>,
                "If you live alone, you’re more likely to need paid care than if you’re married, or single, and living with a partner",
                "Information provided by LongTermCare.gov"
            ]
        },
        {
            title: "Who pays for Long Term Care?",
            text: [
                <strong>The facts may surprise you.</strong>,
                "Consumer surveys reveal common misunderstandings about which public programs pay for long-term care services. It is important to clearly understand what is and isn’t covered.",
                <strong>Medicare</strong>,
                ["Only pays for long-term care if you require skilled services or rehabilitative care:",
                    ["In a nursing home for a maximum of 100 days, however, the average Medicare covered stay is much shorter (22 days).",
                        "At home if you are also receiving skilled home health or other skilled in-home services. Generally, long-term care services are provided only for a short period of time."
                    ],
                    "Does not pay for non-skilled assistance with Activities of Daily Living (ADL), which make up the majority of long-term care services",
                    "You will have to pay for long-term care services that are not covered by a public or private insurance program"],
                <strong>Medicaid</strong>,
                ["Does pay for the largest share of long-term care services, but to qualify, your income must be below a certain level and you must meet minimum state eligibility requirements",
                    "Such requirements are based on the amount of assistance you need with ADL",
                    "Other federal programs such as the Older Americans Act and the Department of Veterans Affairs pay for long-term care services, but only for specific populations and in certain circumstances"
                ],
                "Information provided by LongTermCare.gov"

            ]
        },
        {
            title: "Where can you receive care?",
            text: [
                "Most long-term care is provided at home. Other kinds of long-term care services and supports are provided by community service organizations and in long-term care facilities.",
                <span>Examples of <strong>home care services</strong> include:</span>,
                ["An unpaid caregiver who may be a family member or friend",
                    "A nurse, home health or home care aide, and/or therapist who comes to the home"],
                <span><strong>Community support services</strong> include:</span>,
                ["Adult day care service centers",
                    "Transportation services",
                    "Home care agencies that provide services on a daily basis or as needed"],
                "Often these services supplement the care you receive at home or provide time off for your family caregivers.",
                <span>Outside the home, a variety of <strong>facility-based programs</strong> offer more options:</span>,
                [<span><strong>Nursing homes</strong> provide the most comprehensive range of services, including nursing care and 24-hour supervision</span>,
                <span>Other facility-based choices include <strong>assisted living, board and care homes, and continuing care retirement communities.</strong> With these providers, the level of choice over who delivers your care varies by the type of facility.  You may not get to choose who will deliver services, and you may have limited say in when they arrive.</span>],
                "Information provided by LongTermCare.gov"
            ]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/LTC/FaqData.js